//@ts-nocheck
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

import Card, {
  CardBody,
  CardHeader,
} from "../../../components/bootstrap/Card";
import Checks from "../../../components/bootstrap/forms/Checks";

import { observer } from "mobx-react-lite";

import apiKeyState from "../../../user/mobx/apiKeyState";
import Spinner from "../../../components/bootstrap/Spinner";
import LoaderWrapper from "../../../layout/Wrapper/LoaderWrapper";
import PaginationButtons from "../../../components/PaginationButtons";
import { useParams } from "react-router-dom";
import auth from "../../../shared/mobx/auth-state";
import SearchBar from "../../../components/SearchBar";

import ascendingIcon from "../../../sorting/ascending-sorting.png"; // Import ascending icon
import descendingIcon from "../../../sorting/descending-sorting.png"; // Import descending icon

const KeyUsage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { userId } = useParams();
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalItems, setTotalItems] = useState(0);
  const [GetKeyUsage, setGetKeyUsage] = useState([]);

  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc"); // New state for sorting order
  const [sortField, setSortField] = useState<string>("createdAt"); // New state for sorting field

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [allUsers, setAllUsers] = useState<any[]>([]); // New state to hold all users
  const [filteredData, setFilteredData] = useState<any[]>([]); // New state for filtered data

  const [searchQuery, setSearchQuery] = useState<string>("");

  const fetchData = async () => {
    setLoading(true);
    if (auth.isUser) {
      const d = await apiKeyState.getKeyUsage({
        per_page: perPage,
        page: currentPage,
        search: searchQuery,
        orderBy: sortOrder,
        orderByField: sortField,
      });
      const { data, total_records } = d;
      setAllUsers(d?.data || []);
      setFilteredData(d?.data || []);
      setTotalItems(total_records);
      setGetKeyUsage(data);
      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _data = data;
    } else {
      const { total_records } = await apiKeyState.getUserKeyUsage(
        userId,
        {
          page: currentPage,
          per_page: perPage,
          search: searchQuery,
          orderBy: sortOrder,
          orderByField: sortField,
        }
      );
      setTotalItems(total_records);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, perPage, searchQuery, sortOrder, sortField]);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const searchTerms = query.toLowerCase().trim();
    const results = GetKeyUsage.filter((item) => {
      return (
        item.url.toLowerCase().includes(searchTerms) ||
        item.source.toLowerCase().includes(searchTerms) ||
        item.createdAt.toLowerCase().includes(searchTerms)
      );
    });
    setFilteredData(results);
    setCurrentPage(1); // Reset to the first page on search
  };

  const toggleSortOrder = (field: string) => {
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("desc"); // Reset to ascending when changing field
    }
  };

  const sortedData = filteredData.sort((a, b) => {
    const comparison = a[sortField]?.localeCompare(b[sortField]);
    return sortOrder === "asc" ? comparison : -comparison; // Sort based on order
  });
  const handleToggleStatus = async (keyUsage: number) => {
    await apiKeyState.toggleUsageSourceStatus(keyUsage);
    // Fetch data again to ensure the UI is updated
    fetchData(); // Call fetchData to refresh the data
  };

  return (
    <Card>
      <CardHeader borderSize={1}>
        <div className="search-wrap">
          <span className="fw-bold">Key Usage</span>
          <div className="d-flex justify-content-end gap-8">
            <SearchBar
              fetchData={() => {}}
              placeholder="Search..."
              onSearch={handleSearch}
            />
          </div>
        </div>
      </CardHeader>
      <CardBody className="table-responsive">
        <LoaderWrapper isLoading={loading} data={[true]}>
          <table className="table table-modern">
            <thead>
              <tr>
                <th onClick={() => toggleSortOrder("source")}>
                  <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                    Source
                    {sortField === "source" &&
                      (sortOrder === "asc" ? (
                        <img
                          src={ascendingIcon}
                          alt="Ascending"
                          style={{
                            marginLeft: "5px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                      ) : (
                        <img
                          src={descendingIcon}
                          alt="Descending"
                          style={{
                            marginLeft: "5px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                      ))}
                  </div>
                </th>
                <th onClick={() => toggleSortOrder("url")}>
                  <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                    Url
                    {sortField === "url" &&
                      (sortOrder === "asc" ? (
                        <img
                          src={ascendingIcon}
                          alt="Ascending"
                          style={{
                            marginLeft: "5px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                      ) : (
                        <img
                          src={descendingIcon}
                          alt="Descending"
                          style={{
                            marginLeft: "5px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                      ))}
                  </div>
                </th>

                <th onClick={() => toggleSortOrder("createdAt")}>
                  <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                  created At
                    {sortField === "createdAt" &&
                      (sortOrder === "asc" ? (
                        <img
                          src={ascendingIcon}
                          alt="Ascending"
                          style={{
                            marginLeft: "5px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                      ) : (
                        <img
                          src={descendingIcon}
                          alt="Descending"
                          style={{
                            marginLeft: "5px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                      ))}
                  </div>
                </th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {/* {apiKeyState.usageList && apiKeyState.usageList.length > 0 ? (
                apiKeyState.usageList.map((keyUsage) => ( */}
              {sortedData.length > 0 ? (
                sortedData.map((keyUsage) => (
                  <tr key={keyUsage.id} className="h-20">
                    <td>{keyUsage.source}</td>
                    <td>{keyUsage.url}</td>
                    <td>{dayjs(keyUsage.createdAt).format("MM-DD-YYYY")}</td>
                    <td>
                      {keyUsage.loading ? (
                        <Spinner size="12px" color="primary" />
                      ) : (
                        <Checks
                          id="status"
                          name="status"
                          className="status"
                          type="switch"
                          label={keyUsage.status}
                          onChange={() => handleToggleStatus(keyUsage.id)}
                          checked={keyUsage.status === "Active"}
                        />
                        // <Checks
                        //   id="status"
                        //   name="status"
                        //   className="status"
                        //   type="switch"
                        //   label={keyUsage.status}
                        //   onChange={(e) =>
                        //     apiKeyState.toggleUsageSourceStatus(
                        //       keyUsage.id,
                        //       e.target.checked
                        //     )
                        //   }
                        //   checked={keyUsage.status === "Active"}
                        // />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No record found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </LoaderWrapper>
      </CardBody>
      <PaginationButtons
        label="items"
        setCurrentPage={setCurrentPage}
        totalItems={filteredData.length}
        setPerPage={setPerPage}
        currentPage={currentPage}
      />
    </Card>
  );
};

export default observer(KeyUsage);
